import Image from 'next/image'

interface PageBannerProps {
  title: string
  subtitle?: string
}

export default function PageBanner({ title, subtitle }: PageBannerProps) {
  return (
    <div className="relative h-[30vh] bg-gray-900 overflow-hidden">
      {/* 背景圖片 */}
      <Image
        src="https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3"
        alt="Banner background"
        fill
        className="object-cover"
        priority
      />
      <div className="absolute inset-0 bg-black/60" />
      
      {/* 內容 */}
      <div className="relative h-full container mx-auto px-4 flex flex-col justify-center">
        <h1 className="text-4xl font-bold text-white mb-2">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl text-gray-300">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  )
} 